export enum FilterUrlParamEnum {
  Types = 'types',
  ScreeningTypes = 'screeningTypes',
  Focuses = 'focuses',
  Interests = 'interests',
  Countries = 'countries',
  Years = 'years'
}
